import React, { useRef } from 'react';
import { Button } from '@kambi/spark';

import classes from './CodeBlock.module.css';

const DISPLAY_NONE = 'none';
const DISPLAY_INLINE = 'inline';

const CodeBlock = ({
    initialDisplayedCode,
    moreCode,
    title,
    expectedOutput,
    variant = 'description',
}) => {
    const kambiEllipsesEl = useRef(null);
    const hasMoreText = () =>
        kambiEllipsesEl.current.style.display === DISPLAY_NONE;
    const kambiMoreEl = useRef(null);
    const allCode = moreCode
        ? `${initialDisplayedCode}${moreCode}`
        : initialDisplayedCode;

    const toggleReadMore = (event) => {
        const isReadMoreExpanded = hasMoreText();
        const readMoreBtnText = event.target;

        readMoreBtnText.innerHTML = isReadMoreExpanded
            ? 'Read more'
            : 'Read less';
        kambiEllipsesEl.current.style.display = isReadMoreExpanded
            ? DISPLAY_INLINE
            : DISPLAY_NONE;
        kambiMoreEl.current.style.display = isReadMoreExpanded
            ? DISPLAY_NONE
            : DISPLAY_INLINE;
    };

    const copyToClipboardHandler = (payload) => {
        if (navigator?.clipboard?.writeText) {
            return navigator.clipboard.writeText(payload);
        }
        return Promise.reject('The Clipboard API is not available.');
    };

    const codeBlockVariant =
        variant === 'description'
            ? classes.CodeBlockWithBorder
            : classes.CodeBlockWithoutBorder;

    return (
        <div className={codeBlockVariant}>
            <div className={classes.Header}>
                <div className={classes.Title}>{title}</div>
                {expectedOutput && (
                    <div className={classes.ExpectedOutput}>
                        <span>Expected output</span>: <i>{expectedOutput}</i>
                    </div>
                )}
            </div>
            <pre>
                <code>
                    {initialDisplayedCode}
                    {moreCode ? (
                        <>
                            <span
                                ref={kambiEllipsesEl}
                                className={classes.Ellipses}
                            >
                                ...
                            </span>
                            <span ref={kambiMoreEl} className={classes.More}>
                                {moreCode}
                            </span>
                        </>
                    ) : undefined}
                </code>
                <div className={classes.Button}>
                    {moreCode ? (
                        <>
                            <Button
                                color="primary"
                                variant="outlined"
                                onClick={toggleReadMore}
                            >
                                Read more
                            </Button>{' '}
                        </>
                    ) : undefined}
                    <Button
                        color="primary"
                        variant="contained"
                        onClick={() => copyToClipboardHandler(allCode)}
                    >
                        Copy
                    </Button>
                </div>
            </pre>
        </div>
    );
};

export default CodeBlock;
